// ViewCandidate.jsx
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  Chip,
  Divider,
  Grid,
  Typography,
  Paper,
  Button,
  Popover,
  Tooltip,
} from "@mui/material";

import { MdVerified } from "react-icons/md";

import { RxCrossCircled } from "react-icons/rx";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import Slider from "react-slick";

import { useSelector, useDispatch } from "react-redux";
import { candidateProfilev2 } from "../../../Redux/action/CandidateProfileAction";
import dummyDp from "../../../../src/images/userimg.jpeg";
import Loader from "../../Common/Loader/loader";
import BackButton from "../../Common/BackButton/BackButton";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  AssignmentOutlined,
  BuildOutlined,
  LocationOn,
  SchoolOutlined,
  Verified,
  VerifiedOutlined,
  WorkHistory,
  WorkspacePremiumOutlined,
} from "@mui/icons-material";

// ---------- Project Carousel ----------
const ProjectCarousel = ({ images = [] }) => {
  if (!images?.length) return null;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: images.length > 1 ? 2 : 1,
    speed: 500,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...settings}>
      {images.map((img, i) => (
        <Paper
          key={i}
          elevation={0}
          sx={{ p: 1, display: "flex", justifyContent: "center" }}
        >
          <img
            src={img}
            alt={`project-${i}`}
            style={{
              height: 180,
              width: "90%",
              borderRadius: 8,
              objectFit: "cover",
            }}
          />
        </Paper>
      ))}
    </Slider>
  );
};

// ---------- Main Component ----------
const VendorViewCandidate = () => {
  const dispatch = useDispatch();
  const { candidateId: routeId } = useParams();
  const { userResult } = useSelector((state) => state.Auth);
  const loading = useSelector((state) => state?.Profile?.loading);
  const [candidateId, setCandidateId] = useState(null);
  const [anchorElPrice, setAnchorElPrice] = useState(null);
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const [pricingData, setPricingData] = useState({});
  const candidateProfile =
    useSelector((state) => state?.Profile?.candidateProfile) || {};

  const isPricingEmpty =
    pricingData &&
    !pricingData.perHour &&
    !pricingData.perDay &&
    !pricingData.perWeek &&
    !pricingData.perMonth;
  useEffect(() => {
    let queryId = null;
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      queryId = params.get("candidateId");
    }

    const finalId =
      queryId ||
      routeId ||
      userResult?.userid ||
      userResult?.id ||
      candidateProfile?.candidateId;
    setCandidateId(finalId);
    const getPricing = async () => {
      if (!finalId) return;
      const response = await axios.get(
        `${process.env.REACT_APP_API_PATH}/ebench/candidate/${finalId}/price`
      );
      const data = response?.data?.data;
      setPricingData(data);
    };
    getPricing();
  }, []);

  useEffect(() => {
    if (candidateId) {
      dispatch(candidateProfilev2(candidateId));
    }
  }, [dispatch, candidateId]);

  const statusBadge = candidateProfile?.emailVerified
    ? {
        label: "Verified",
        icon: <MdVerified color="#2b9348" />,
        sx: { background: "#d1fadf", color: "#1e7a40" },
      }
    : {
        label: "Unverified",
        icon: <RxCrossCircled color="red" />,
        sx: { background: "#ffe1e1", color: "#b91c1c" },
      };

  const handlePriceClick = (e) => {
    setAnchorElPrice(anchorElPrice ? null : e.currentTarget);
    setIsPricingOpen((v) => !v);
  };
  const openPrice = Boolean(anchorElPrice);

  // loading
  if (loading) {
    return (
      <Box
        sx={{
          height: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ px: 3, paddingBottom: 4, paddingTop: 0.5 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4} lg={3}>
            <Box
              sx={{
                position: { xs: "static", md: "sticky" },
                top: 20,
                minWidth: "350px",
                zIndex: 5,
              }}
            >
              <Card
                sx={{
                  p: { xs: 2, md: 3 },
                  borderRadius: 4,
                  textAlign: "center",
                  background: "linear-gradient(135deg, #EBF5FF, #FFFFFF)",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <BackButton />
                </Box>

                <Avatar
                  src={dummyDp}
                  imgProps={{
                    loading: "eager",
                    decoding: "async",
                  }}
                  sx={{
                    width: 200,
                    height: 200,
                    mx: "auto",
                    mb: 2,
                    border: "4px solid #fff",
                    boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                  }}
                />
                <Chip
                  icon={statusBadge.icon}
                  label={statusBadge.label}
                  size="small"
                  sx={{ ...statusBadge.sx, mt: 1, fontWeight: 600 }}
                />

                <Divider sx={{ my: 2 }} />
                <Box sx={{ mt: 0.5, textAlign: "left" }}>
                  <Typography
                    fontWeight={700}
                    sx={{
                      textTransform: "uppercase",
                      fontSize: "13px",
                      opacity: 0.9,
                      mb: 1.5,
                    }}
                  >
                    Availability
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      component={"div"}
                      sx={{
                        fontSize: "15px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      This candidate is
                      <Chip
                        label={
                          candidateProfile?.availableForWork
                            ? "Available"
                            : "Unavailable"
                        }
                        sx={{
                          fontWeight: 600,
                          p: 0.5,
                          color: candidateProfile?.availableForWork
                            ? "#1E7A40"
                            : "#B91C1C",
                          background: candidateProfile?.availableForWork
                            ? "#D1FADF"
                            : "#FFE1E1",
                          borderRadius: "6px",
                        }}
                      />
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Grid>

          <Grid item xs={12} md={8} lg={9}>
            <Card
              sx={{
                p: 4,
                borderRadius: 4,
                boxShadow: "0px 8px 24px rgba(0,0,0,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: 2,
                  pb: 1,
                }}
              >
                {/* LEFT SIDE */}
                <Box>
                  {/* Designation + Verified */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        color: "#0f172a",
                        lineHeight: 1.3,
                      }}
                    >
                      {candidateProfile?.currentDesignation || "N/A"}
                    </Typography>

                    <Tooltip
                      title={
                        candidateProfile?.emailVerified
                          ? "Verified profile"
                          : "Profile not verified"
                      }
                    >
                      {candidateProfile?.emailVerified ? (
                        <Verified
                          sx={{
                            color: "#2b9348",
                            fontSize: 22,
                          }}
                        />
                      ) : (
                        <VerifiedOutlined
                          sx={{
                            color: "#b91c1c",
                            fontSize: 22,
                          }}
                        />
                      )}
                    </Tooltip>
                  </Box>

                  {/* Candidate ID */}
                  <Box
                    sx={{
                      mt: 0.8,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.8,
                      px: 1.5,
                      py: 0.4,
                      borderRadius: 999,
                      background: "#F1F7FB",
                      border: "1px solid #E2E8F0",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#64748b",
                        fontWeight: 500,
                        textTransform: "uppercase",
                      }}
                    >
                      Candidate ID :
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: "#286a94",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {candidateProfile?.candidateEmpId || "--"}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {pricingData && (
                    <>
                      <Button
                        variant="outlined"
                        onClick={handlePriceClick}
                        startIcon={
                          <PaidOutlinedIcon sx={{ color: "#215b7f" }} />
                        }
                        endIcon={
                          isPricingOpen ? (
                            <FaChevronDown size={14} />
                          ) : (
                            <FaChevronRight size={14} />
                          )
                        }
                        sx={{
                          textTransform: "none",
                          borderColor: "#215b7f",
                          color: "#215b7f",
                          fontWeight: 600,
                          px: 2.2,
                          "&:hover": {
                            backgroundColor: "rgba(33, 91, 127, 0.1)",
                            borderColor: "#215b7f",
                          },
                        }}
                      >
                        Price
                      </Button>

                      <Popover
                        open={openPrice}
                        anchorEl={anchorElPrice}
                        onClose={() => {
                          setAnchorElPrice(null);
                          setIsPricingOpen(false);
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        <Paper
                          sx={{
                            p: 1.5,
                            minWidth: 230,
                            borderRadius: 2,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          {(() => {
                            const currency = pricingData?.currency;
                            const currencySymbol =
                              currency === "INR"
                                ? "₹"
                                : currency === "USD"
                                ? "$"
                                : currency + " ";
                            if (isPricingEmpty) {
                              return (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#64748b",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    py: 1,
                                  }}
                                >
                                  No information available
                                </Typography>
                              );
                            }
                            return (
                              <>
                                {/* Per Hour */}
                                {pricingData?.perHour && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {pricingData.perHour} / hr
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Day */}
                                {pricingData?.perDay && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {pricingData?.perDay} / day
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Week */}
                                {pricingData?.perWeek && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {pricingData?.perWeek} / week
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Month */}
                                {pricingData?.perMonth && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {pricingData?.perMonth} / month
                                    </Typography>
                                  </>
                                )}
                                {/* {pricingData?.salaryMode === "CTC" &&
                                  pricingData?.ctc && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {pricingData?.ctc} / CTC
                                      </Typography>
                                    </>
                                  )} */}
                              </>
                            );
                          })()}
                        </Paper>
                      </Popover>
                    </>
                  )}
                </Box>
              </Box>

              {candidateProfile?.overview && (
                <Box
                  sx={{
                    mt: 3.5,
                    p: 2.5,
                    borderRadius: 3,
                    background: "#F8FAFC",
                    borderLeft: "4px solid #286a94",
                  }}
                >
                  {/* Label */}
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#286a94",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      mb: 0.75,
                    }}
                  >
                    Professional Summary
                  </Typography>

                  {/* Content */}
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: "#475569",
                      lineHeight: 1.7,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {candidateProfile.overview}
                  </Typography>
                </Box>
              )}

              <Divider sx={{ my: 4 }} />

              <Box sx={{ mt: 4 }}>
                <Grid container spacing={2}>
                  {/* Location */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        background: "#F1F7FB",
                        border: "1px solid #E2E8F0",
                        display: "flex",
                        gap: 1.5,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 42,
                          height: 42,
                          borderRadius: "50%",
                          background: "#E6F0F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LocationOn sx={{ color: "#286a94" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#286a94",
                            textTransform: "uppercase",
                          }}
                        >
                          Location
                        </Typography>
                        <Typography sx={{ color: "#475569", fontSize: 14 }}>
                          {candidateProfile?.city || "—"}
                          {candidateProfile?.state
                            ? `, ${candidateProfile.state}`
                            : ""}
                          {candidateProfile?.country
                            ? `, ${candidateProfile.country}`
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Experience */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        background: "#F1F7FB",
                        border: "1px solid #E2E8F0",
                        display: "flex",
                        gap: 1.5,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 42,
                          height: 42,
                          borderRadius: "50%",
                          background: "#E6F0F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <WorkHistory sx={{ color: "#286a94" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#286a94",
                            textTransform: "uppercase",
                          }}
                        >
                          Experience
                        </Typography>
                        <Typography sx={{ color: "#475569", fontSize: "15px" }}>
                          {(() => {
                            const yearsRaw = parseInt(
                              candidateProfile?.keyExperience,
                              10
                            );
                            const monthsRaw = parseInt(
                              candidateProfile?.keyExperienceInMonth,
                              10
                            );
                            const years = Number.isNaN(yearsRaw) ? 0 : yearsRaw;
                            const months = Number.isNaN(monthsRaw)
                              ? 0
                              : monthsRaw;

                            if (years === 0 && months === 0) {
                              return "Fresher";
                            }
                            if (years === 0) {
                              return `${months} Month${months > 1 ? "s" : ""}`;
                            }
                            if (months === 0) {
                              return `${years} Year${years > 1 ? "s" : ""}`;
                            }
                            return `${years} Year${
                              years > 1 ? "s" : ""
                            } ${months} Month${months > 1 ? "s" : ""}`;
                          })()}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 4 }} />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BuildOutlined
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography variant="h6" fontWeight={700} color="#286a94">
                      Skills
                    </Typography>
                    <Typography sx={{ fontSize: 13, color: "#64748b" }}>
                      Technical & professional expertise
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.2, mt: 1 }}>
                {(candidateProfile?.skills || []).length > 0 ? (
                  candidateProfile?.skills?.map((item, idx) => (
                    <Chip
                      key={idx}
                      label={item}
                      sx={{
                        background: "#e9f2ff",
                        borderRadius: "999px",
                        px: 2,
                        py: 1,
                        fontWeight: 600,
                        fontSize: "13px",
                      }}
                    />
                  ))
                ) : (
                  <Typography sx={{ color: "#475569" }}>
                    No skills added
                  </Typography>
                )}
              </Box>

              <Divider sx={{ my: 4 }} />

              {/* PROJECTS */}
              <Box sx={{ mt: 4 }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AssignmentOutlined
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Projects
                  </Typography>
                </Box>

                {(!candidateProfile?.candidateProjects ||
                  candidateProfile?.candidateProjects.length === 0) && (
                  <Box
                    sx={{
                      mt: 3,
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                    }}
                  >
                    <Typography
                      sx={{ mb: 2, fontSize: "16px", color: "#4b5563" }}
                    >
                      No projects added yet.
                    </Typography>
                  </Box>
                )}

                {candidateProfile?.candidateProjects?.length > 0 && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <Box sx={{ mt: 2 }}>
                      {candidateProfile.candidateProjects.map((proj, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            background: "#F9FAFB",
                            border: "1px solid #E5E7EB",
                            borderRadius: 3,
                            p: 3,
                            mb: 3,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                            }}
                          >
                            <Chip
                              label={`#${idx + 1}`}
                              sx={{
                                background: "#286a94",
                                color: "white",
                                mr: 2,
                                fontWeight: 600,
                              }}
                            />
                            <Typography
                              sx={{ fontSize: "18px", fontWeight: 600 }}
                            >
                              {proj.projectName || "Untitled Project"}
                            </Typography>
                          </Box>

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Role
                              </Typography>
                              <Typography sx={{ color: "#475569" }}>
                                {proj.role || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Duration
                              </Typography>
                              <Typography sx={{ color: "#475569" }}>
                                {proj.duration || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Project URL
                              </Typography>
                              {proj?.projectUrl ? (
                                <Typography
                                  component="a"
                                  href={
                                    proj.projectUrl.startsWith("http")
                                      ? proj.projectUrl
                                      : `https://${proj.projectUrl}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    fontSize: "15px",
                                    color: "#2563eb",
                                    wordBreak: "break-word",
                                    cursor: "pointer",
                                    "&:hover": { textDecoration: "underline" },
                                  }}
                                >
                                  {proj.projectUrl}
                                </Typography>
                              ) : (
                                <Typography sx={{ color: "#475569" }}>
                                  --
                                </Typography>
                              )}
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Description
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#475569",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {proj.description || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Technologies
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 1,
                                  mt: 1,
                                }}
                              >
                                {proj?.technologies?.length > 0 ? (
                                  proj.technologies.map((t, i) => (
                                    <Chip
                                      key={i}
                                      label={t}
                                      sx={{
                                        background: "#eef6ff",
                                        fontWeight: 500,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <Typography sx={{ color: "#475569" }}>
                                    --
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                          </Grid>

                          {proj?.projectImages?.length > 0 && (
                            <Box sx={{ mt: 3 }}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  mb: 1,
                                  fontSize: "14px",
                                  color: "#0E3F6F",
                                }}
                              >
                                Screenshots
                              </Typography>
                              <ProjectCarousel images={proj.projectImages} />
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </>
                )}
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* EDUCATION */}
              <Box sx={{ mt: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SchoolOutlined
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Education
                  </Typography>
                </Box>
                <Divider sx={{ my: 3 }} />

                {(!candidateProfile?.educations ||
                  candidateProfile?.educations?.length === 0) && (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                      color: "#475569",
                    }}
                  >
                    🎓 No education records found.
                  </Box>
                )}

                {candidateProfile?.educations?.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {candidateProfile?.educations?.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          mb: 2.5,
                          background: "#F9FAFB",
                          border: "1px solid #E5E7EB",
                          "&:hover": { background: "#f1f8ff" },
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <Chip
                            label={`#${idx + 1}`}
                            sx={{
                              background: "#286a94",
                              color: "white",
                              mr: 2,
                              fontWeight: 600,
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "18px", fontWeight: 600 }}
                          >
                            {item?.degreeName || item?.type || "Education"}
                          </Typography>
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              University / Board
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.institutionName ||
                                item?.board ||
                                item?.university ||
                                "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              Passing Year
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.educationStatus === "PURSUING"
                                ? "Pursuing"
                                : item?.passingYear || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              Grade / Percentage
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.percentage ? `${item.percentage}%` : "--"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* CERTIFICATIONS */}
              <Box sx={{ mt: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <WorkspacePremiumOutlined
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Certifications
                  </Typography>
                </Box>
                <Divider sx={{ my: 3 }} />

                {(!candidateProfile?.candidateCertificate ||
                  candidateProfile?.candidateCertificate.length === 0) && (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                      color: "#475569",
                    }}
                  >
                    🎓 No certifications added yet.
                  </Box>
                )}

                {candidateProfile?.candidateCertificate?.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {candidateProfile.candidateCertificate.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          background: "#F9FAFB",
                          border: "1px solid #E5E7EB",
                          p: 2.5,
                          borderRadius: 3,
                          mb: 2.5,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <Chip
                            label={`#${idx + 1}`}
                            sx={{
                              background: "#286a94",
                              color: "white",
                              mr: 2,
                              fontWeight: 600,
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "18px", fontWeight: 600 }}
                          >
                            {item?.courseName || "Untitled Certification"}
                          </Typography>
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Issued By
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.courseProvider || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Duration
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.duration || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Issued Year
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.year || "--"}
                            </Typography>
                          </Grid>

                          {item?.certificateImageUrl && (
                            <Grid item xs={12}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#0E3F6F",
                                }}
                              >
                                Certificate
                              </Typography>
                              <Typography
                                component="a"
                                href={item.certificateImageUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  fontSize: "15px",
                                  color: "#2563eb",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 1,
                                  textDecoration: "none",
                                  "&:hover": { textDecoration: "underline" },
                                }}
                              >
                                📄 View Document
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default VendorViewCandidate;
